import { render } from "./PageProjectMgmt.vue?vue&type=template&id=3444c42c&scoped=true&ts=true"
import script from "./PageProjectMgmt.vue?vue&type=script&lang=ts"
export * from "./PageProjectMgmt.vue?vue&type=script&lang=ts"

import "./PageProjectMgmt.vue?vue&type=style&index=0&id=3444c42c&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3444c42c"]])

export default __exports__